// src/styles/shared.js

// ─── Brand colours ──────────────────────────────────────────────
export const PRIMARY    = '#01696F';
export const BORDER     = '#e2e8f0';
export const BG_PAGE    = '#f8fafc';
export const BG_CARD    = '#ffffff';
export const TEXT_DARK  = '#1e293b';
export const TEXT_MID   = '#475569';
export const TEXT_LIGHT = '#64748b';
export const TEXT_MUTED = '#94a3b8';
export const RED        = '#ef4444';

// ─── Accent colours ────────────────────────────────────────────
export const ACCENT_BLUE   = '#3b82f6';
export const ACCENT_PURPLE = '#8b5cf6';
export const ACCENT_ORANGE = '#f97316';
export const ACCENT_PINK   = '#ec4899';
export const ACCENT_GREEN  = '#22c55e';
export const ACCENT_YELLOW = '#eab308';
export const ACCENT_CYAN   = '#06b6d4';

// Aliases used in some components
export const COLORS = {
  PRIMARY,
  ERROR: RED,
  SUCCESS: '#16a34a',
  NEUTRAL_50: BG_PAGE,
  NEUTRAL_200: BORDER,
  NEUTRAL_500: TEXT_MUTED,
  NEUTRAL_600: TEXT_LIGHT,
  TEXT: TEXT_DARK,
};

// ─── Base style objects ──────────────────────────────────────────
export const formGroup = { marginBottom: '1.25rem' };

export const label = {
  display: 'block',
  fontSize: '0.875rem',
  fontWeight: '500',
  color: TEXT_DARK,
  marginBottom: '0.4rem',
};

/**
 * input — base style for all <input> and <select> elements.
 * Vertical padding is 0.75rem so the effective height exceeds 44px.
 */
export const input = {
  width: '100%',
  padding: '0.75rem 0.875rem',
  borderRadius: '8px',
  border: `1px solid ${BORDER}`,
  fontSize: '0.9rem',
  color: TEXT_DARK,
  outline: 'none',
  lineHeight: '1.4',
  boxSizing: 'border-box',
};

export const inputFocus = {
  borderColor: PRIMARY,
  boxShadow: `0 0 0 3px ${PRIMARY}33`,
};

export const card = {
  backgroundColor: BG_CARD,
  border: `1px solid ${BORDER}`,
  borderRadius: '10px',
  padding: '1.25rem',
};

/**
 * btn — base for all buttons.
 * Vertical padding 0.75rem achieves ≥44px tap target at font-size 0.875rem.
 */
export const btn = {
  padding: '0.75rem 1.25rem',
  borderRadius: '8px',
  border: 'none',
  cursor: 'pointer',
  fontSize: '0.875rem',
  fontWeight: '600',
  transition: 'opacity 0.15s',
  minHeight: '44px',
};

export const primaryBtn = { backgroundColor: PRIMARY, color: '#ffffff' };
export const primaryBtnHover = { backgroundColor: '#028a92', color: '#ffffff' };
export const outlineBtn = { backgroundColor: BG_CARD, color: PRIMARY, border: `1px solid ${PRIMARY}` };
export const dangerBtn  = { backgroundColor: '#fef2f2', color: RED, border: '1px solid #fecaca' };

// Alias sets for components that use `sharedStyles` object pattern
export const sharedStyles = {
  formGroup,
  label,
  inputBase: input,
  cardBase: card,
  btnBase: btn,
  primaryBtn,
  primaryBtnHover,
  errorBanner: {
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca',
    color: RED,
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '0.875rem',
    marginBottom: '1rem',
  },
  successBanner: {
    backgroundColor: '#f0fdf4',
    border: '1px solid #bbf7d0',
    color: '#16a34a',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '0.875rem',
    marginBottom: '1rem',
  },
};
